module.exports = __webpack_public_path__ + "img/chrome15.3b0e807a.png";